import { useFadeInScroll } from "../Animation/fadeinScroll";
const HeroSection = () => {


  const title = useFadeInScroll<HTMLDivElement>();
  const body = useFadeInScroll<HTMLParagraphElement>();
  return (
    <section
      className="
        relative
        flex items-center justify-center
      "
    >
      {/* Background accents */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 sm:-top-32 sm:-left-32 w-[280px] sm:w-[420px] h-[280px] sm:h-[420px] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute bottom-0 -right-20 sm:-right-24 w-[240px] sm:w-[360px] h-[240px] sm:h-[360px] rounded-full bg-secondary/10 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl text-center">
        <div
          ref={title.ref}
          className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-6"}
            `}
        >
          <h2
            className="
           text-hero text-primary font-primary
            mb-4 sm:mb-5
          "
          >
            Reimagining Orthopedic Recovery<br></br> Through Technology
          </h2>
        </div>
        <p
          ref={body.ref}
          className={`
            max-w-xl sm:max-w-2xl md:max-w-3xl lg:max-w-4xl
            mx-auto
           text-body text-text-secondary
            mb-4
              ${body.isVisible ? "opacity-100" : "opacity-0 translate-y-4"}
            `}

        >
          <strong>SACRUM 3D</strong> is a medical technology company focused on
          delivering customized orthopedic solutions through advanced 3D
          manufacturing.
        </p>

        <p
          ref={body.ref}
          className={`
            max-w-xl sm:max-w-2xl md:max-w-3xl lg:max-w-4xl
            mx-auto
            text-body text-text-secondary
            mb-5
            ${body.isVisible ? "opacity-100" : "opacity-0 translate-y-4"}
            `}
        >
          We leverage advanced digital design and 3D manufacturing to create
          personalized orthopedic solutions that enable patients to recover
          without disrupting their daily lives.
        </p>



        <span
          ref={body.ref}
          className={`
    inline-flex items-center gap-2
    px-4 py-1.5
    rounded-full
    bg-primary/10
   text-body text-text-secondary
    ${body.isVisible ? "opacity-100" : "opacity-0 translate-y-4"}
            `}
        >
          Bespoke. Personalization. Better outcomes.
        </span>
      </div>



    </section>
  );
};

export default HeroSection;
